/**
 * Custom TextareaWidget — limita a entrada pelo `maxLength` enquanto o usuário digita.
 */

import React from 'react';
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { TextArea } from 'semantic-ui-react';

const TextareaWidget = (props) => {
  const { id, maxLength, value, onChange, placeholder, required, invalid } =
    props;

  const onhandleChange = (id, value) => {
    if (maxLength && value?.length) {
      const ml = Number(maxLength);
      if (ml > 0 && value.length > ml) {
        value = value.slice(0, ml);
      }
    }
    onChange(id, value);
  };

  let attributes = {};
  if (required) {
    attributes.required = true;
    attributes['aria-required'] = true;
  }

  const isInvalid = invalid === true || invalid === 'true';
  if (isInvalid) {
    attributes['aria-invalid'] = true;
  }

  return (
    <FormFieldWrapper {...props} className="textarea">
      <TextArea
        id={`field-${id}`}
        name={id}
        value={value || ''}
        disabled={props.isDisabled}
        placeholder={placeholder}
        onChange={({ target }) =>
          onhandleChange(id, target.value === '' ? undefined : target.value)
        }
        {...attributes}
        maxLength={maxLength || null}
      />
    </FormFieldWrapper>
  );
};

TextareaWidget.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  maxLength: PropTypes.number,
  required: PropTypes.bool,
  error: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  onChange: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  wrapped: PropTypes.bool,
  placeholder: PropTypes.string,
};

TextareaWidget.defaultProps = {
  description: null,
  maxLength: null,
  required: false,
  error: [],
  value: null,
  onChange: null,
  onEdit: null,
  onDelete: null,
};

export default injectIntl(TextareaWidget);
